<template>
    <div class="planEmail">
        <Row type="flex" justify="space-between" class="code-row-bg" style="margin-bottom: 20px">
            <Col span="8">
                <Card class="page-title no-padding" dis-hover :bordered="false">
                    SEND WEEKLY PLAN EMAIL <span style="text-transform: uppercase"></span
                ></Card>
            </Col>
            <Col span="4" class="text-right">
                <Button class="pt-btn-5" style="margin-right: 10px; padding: 0 30px">
                    <strong>Go Back</strong>
                </Button>
            </Col>
        </Row>
        <Card>
            <div class="sendBtn">
                <Button class="pt-btn-1" style="width: 100px" :loading="isSending"> Send </Button>
            </div>
            <TinyMceEditor />
        </Card>
        <Row type="flex" class="taskTodoList">
            <Col span="12">
                <Card
                    ><h3 class="headTitle">TASKS TO DO</h3>
                    <Table
                        :columns="tblColumns"
                        :data="tblData"
                        height="200"
                        size="small"
                        :loading="isLoading"
                        class="todoTasks"
                /></Card>
            </Col>
            <Col span="12">
                <Card
                    ><h3 class="headTitle">OTHER TASKS</h3>
                    <Table
                        :columns="tblColumns"
                        :data="tblData"
                        height="200"
                        size="small"
                        :loading="isLoading"
                        class="otherTasks"
                /></Card>
            </Col>
        </Row>
    </div>
</template>

<script>
import TinyMceEditor from '@/components/UI/TinyMceEditor';

export default {
    components: {
        TinyMceEditor,
    },
    data() {
        return {
            tblColumns: [
                // {
                //     type: 'selection',
                //     width: 60,
                //     align: 'center',
                // },
                {
                    title: 'Task Title',
                    key: 'name',
                },
                {
                    title: 'Due Date',
                    key: 'due',
                    width: 300,
                },
                {
                    title: 'Hours #',
                    key: 'hours',
                    width: 90,
                },
            ],
            tblData: [],
        };
    },
};
</script>
<style lang="scss">
.sendBtn {
    display: flex;
    justify-content: end;
    margin-bottom: 15px;
}
.planEmail .ivu-card.ivu-card-bordered {
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    border-color: #eee;
    border-radius: 20px;
}
.taskTodoList {
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
}
.ivu-col-span-12 {
    max-width: 49%;
}
.headTitle {
    color: #463c6e;
}
.todoTasks .ivu-table th {
    background-color: unset;
    color: #463c6e;
}
.otherTasks .ivu-table th {
    background-color: unset;
    color: #463c6e;
}
</style>
